<script setup>
import { ref, onMounted, getCurrentInstance, inject, computed } from "vue";
import { useRouter, RouterLink } from "vue-router";
import adminJobfairService from "../../services/jobfair/adminJobfairService";
import SNBAdmin from "../../../../layouts/nav/SNBAdmin.vue";
import { usePageLoadingStore } from "../../../../stores/pageLoading";
import _ from "lodash";
import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";

const router = useRouter();

const loadingStore = usePageLoadingStore();
const { $pageListBoardNo, $toast, $gbNameKR, $number, $yyyymmdd, $yyyymmddHHmmss, $ojfStateGb } = getCurrentInstance().appContext.config.globalProperties;

onMounted(() => {
  retrieveCount();
  retrieveList();
});

const resultCount = ref({});
const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchOpen = ref(true);

const ojfStateGb = ref($ojfStateGb);
const openYnListRef = ref(null);
const ojfStateGbListRef = ref(null);

const ojfList = ref([]);

// 검색 조건
const searchInput = ref({
    openYnList: ["Y", "N"],
    ojfStateGbList: ["00", "01", "02", "03", "04"],
    searchOjfName: ""
});

const GroupOpenYn = ref([
    { label: "공개", value: "Y" },
    { label: "비공개", value: "N" }
]);

const pageSizeGroup = ref([
    { label: "10개씩 보기", value: "10" },
    { label: "30개씩 보기", value: "30" },
    { label: "50개씩 보기", value: "50" },
    { label: "100개씩 보기", value: "100" }
]);

const retrieveList = async () => {
    let paramObj = {
        searchOpenYn: _.map(searchInput.value.openYnList).join(","),
        searchOjfStateGb: _.map(searchInput.value.ojfStateGbList).join(","),
        searchOjfName: searchInput.value.searchOjfName,
        pageNumber: currentPage.value,
        size: pageSize.value
    };

    adminJobfairService.retrieveAllOnlineJobFairList(paramObj)
        .then(async (res) => {
            if (res.data.code.toLowerCase() === "success") {
                const result = res.data.result;
                totalPages.value = result.totalPages;
                totalCount.value = result.totalElements;
                ojfList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
            $toast("error", res);
    });
};

const retrieveCount = () => {
    loadingStore.loading = true;
    let paramObj = {
        searchOpenYn: _.map(searchInput.value.openYnList).join(","),
        searchOjfStateGb: _.map(searchInput.value.ojfStateGbList).join(","),
        searchOjfName: searchInput.value.searchOjfName,
        pageNumber: currentPage.value,
        size: pageSize.value
    };

    adminJobfairService.retrieveOnlineJobFairTotalCount(paramObj)
        .then((res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                resultCount.value = res.data.result;
            } else {

            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

const clearSearchInput = () => {
    searchInput.value = {
        openYnList: ["Y", "N"],
        ojfStateGbList: ["00", "01", "02", "03", "04"],
        searchOjfName: ""
    };
    openYnListRef.value.initOptions();
    ojfStateGbListRef.value.initOptions();
};

const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
};

const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
};

const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
};

</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>행사 목록</h3>
        </div>

        <div class="table-form">
            <table class="horizontal all-border">
                <tr class="tr-focus-top tr-focus-side">
                    <th rowspan="2">전체 현황</th>
                    <th class="total">전체</th>
                    <th class="th-blue">{{ $gbNameKR("OJF_STATE_GB", "03") }}</th>
                    <th class="th-red">{{ $gbNameKR("OJF_STATE_GB", "01") }}</th>
                    <th class="th-red">{{ $gbNameKR("OJF_STATE_GB", "02") }}</th>
                    <th>{{ $gbNameKR("OJF_STATE_GB", "04") }}</th>
                </tr>
                <tr class="tr-focus-side tr-focus-bottom">
                    <td>{{ resultCount.totalOjfState }}</td>
                    <td>{{ resultCount.ojfState03 }}</td>
                    <td>{{ resultCount.ojfState01 }}</td>
                    <td>{{ resultCount.ojfState02 }}</td>
                    <td>{{ resultCount.ojfState04 }}</td>
                </tr>
            </table>
        </div>
        <br>
        <!-- s: 검색 -->
        <div class="filter-wrap" :class="{'open': searchOpen}">
            <p @click="searchOpen = !searchOpen">검색</p>
            <div class="filter">
                <dl>
                    <dt style="display:block;"><span>공개 상태</span><br /><small style="font-weight: normal;">복수 선택
                        가능</small></dt>
                    <dd>
                        <KSACheckBoxGroup
                            ref="openYnListRef"
                            className="mr-md"
                            name="openYnList"
                            v-model="searchInput.openYnList"
                            :options="GroupOpenYn" />
                    </dd>
                </dl>
                <dl>
                    <dt style="display:block;"><span>진행 상태</span><br /><small style="font-weight: normal;">복수 선택
                        가능</small></dt>
                    <dd>
                        <KSACheckBoxGroup
                            ref="ojfStateGbListRef"
                            className="mr-md"
                            name="ojfStateGbList"
                            v-model="searchInput.ojfStateGbList"
                            :options="ojfStateGb" />
                    </dd>
                </dl>
                <dl>
                    <dt>행사명</dt>
                    <dd>
                        <KSAInput class="text-box" v-model="searchInput.searchOjfName"
                                    placeholder="행사명을 입력해 주세요." />
                    </dd>
                </dl>
                <div class="btn-wrap">
                    <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                    <KSAPrimaryButton text="검색" @click="onClickSearch" />
                </div>
            </div>
        </div>
        <!-- e: 검색 -->
        <!-- s: 버튼영역 -->
        <div class="list-top">
            <KSAPrimaryButton text="행사 등록" @click="router.push( { name:'OjfCreate', params:{id: 0} } )" />
        </div>
        <div class="list-top">
            <p>전체 <span>{{ $number(totalCount) }}</span>건</p>
            <div>
                <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
            </div>
        </div>
        <!-- e: 버튼영역 -->
        <!-- s: 행사 리스트 -->
        <div class="table-form">
            <table class="horizontal" v-if="ojfList !== null">
                <tr>
                    <th>NO</th>
                    <th>행사ID</th>
                    <th>행사구분</th>
                    <th>공개 상태</th>
                    <th>진행 상태</th>
                    <th>행사명</th>
                    <th>접수기간</th>
                    <th>행사기간</th>
                    <th>최근수정일</th>
                    <th>등록일</th>
                </tr>
                <tr v-for="ojf in ojfList">
                    <td>{{ ojf.boardNo }}</td>
                    <td>{{ ojf.ojfId }}</td>
                    <td>
                        <span v-if="ojf.ojfGb === '01'">기업공채관</span>
                        <span v-else>채용박람회</span>
                    </td>
                    <td>
                        <span v-if="ojf.openYn === 'Y'">공개</span>
                        <span v-else>비공개</span>
                    </td>
                    <td>
                        <!-- 상태가 '03'일 때 -->
                        <span v-if="ojf.ojfStateGb === '03'" class="blue">
                            {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
                            {{ $isInRegPeriod(ojf.regStartYmd, ojf.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(ojf.regEndYmd) ? '(신청 마감)' : '') }}
                        </span>
                        <!-- 상태가 '03'이 아닐 때 -->
                        <span v-else :class="ojf.ojfStateGb === '05' ? 'red' : ojf.ojfStateGb === '04' ? 'gray' : ''">
                        {{ $gbNameKR("OJF_STATE_GB", ojf.ojfStateGb) }}
                        </span>
                    </td>
                    <td class="clickable blue">
                        <RouterLink :to="{name:'OjfDetail', params:{id: ojf.ojfId}}">{{ ojf.ojfName }}
                        </RouterLink>
                    </td>
                    <td>{{ $yyyymmdd(ojf.regStartYmd) }} ~ {{ $yyyymmdd(ojf.regEndYmd) }}</td>
                    <td>{{ $yyyymmdd(ojf.ojfStartYmd) }} ~ {{ $yyyymmdd(ojf.ojfEndYmd) }}</td>
                    <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                    <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                </tr>
            </table>
            <div class="result-none" v-if="ojfList.length === 0">
                등록된 행사가 없습니다.
            </div>
        </div>
        <Paginate
            v-if="ojfList.length > 0"
            v-model="currentPage"
            :page-count="totalPages"
            :click-handler="onSelectPage"
        />
        <!-- e: 행사 리스트 -->
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
.blue {
  color: $blue_color;
}
.red {
  color: $red_color;
}
.gray {
  color: $gray_color;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
